import { render, staticRenderFns } from "./UserActivityItem.vue?vue&type=template&id=3bfeec09&scoped=true&"
import script from "./UserActivityItem.vue?vue&type=script&setup=true&lang=js&"
export * from "./UserActivityItem.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./UserActivityItem.vue?vue&type=style&index=0&id=3bfeec09&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bfeec09",
  null
  
)

export default component.exports